module.exports = __webpack_public_path__ + "img/win.a40a0d7c.png";